import Vue from 'vue'
import locale from 'element-ui/lib/locale'
import VueI18n from 'vue-i18n'
import messages from './lang/index.js'

Vue.use(VueI18n)

// function getQueryString (name) {
//   var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
//   var r = window.location.search.substr(1).match(reg)
//   if (r != null) {
//     return unescape(r[2])
//   }
//   return null
// }

// const translate = getQueryString('lang') || localStorage.getItem('lang') || 'en'

// const i18n = new VueI18n({
//   locale: translate,
//   messages: {
//     'en': require('./components/i18n/lang/en.js'), // eslint-disable-line
//     'zh': require('./components/i18n/lang/zh.js') // eslint-disable-line
//   }
// })

/**
 * @需要处理的问题

function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

const lang = getQueryString('lang') || localStorage.getItem('lang') || 'en'

*/

// const lang = 'en'


function getFirstRouteFromRedirectUrl() {
  // 获取 URL 参数中的 redirect_url 值
  var redirectUrl = new URLSearchParams(window.location.search).get('redirect_url');
  if (redirectUrl) {
    try {
      var url = new URL(decodeURIComponent(redirectUrl)); // 解码并解析 URL
      var pathSegments = url.pathname.split('/').filter(Boolean); // 获取路径并分割
      return pathSegments.length > 0 ? pathSegments[0] : null; // 返回第一个路由段
    } catch (e) {
      console.error('Invalid redirect_url:', e);
    }
  }
  return null; // 未找到 redirect_url
}

// console.log(window.location.href)
// console.log(router.query.redirect_url)
// const lang = getFirstRouteFromRedirectUrl() || localStorage.getItem('lang') || 'en'
const lang = 'en'

const i18n = new VueI18n({
  locale: lang,
  messages
})

locale.i18n((key, value) => i18n.t(key, value))

export default i18n
